export function constructCalendarDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      "name": "資源コード",
      "key": "resourceCode",
    },
    {
      "name": "日指定",
      "key": "dates"
    },
    {
      name: "シフトコード",
      key: "shiftCode",
    },
    {
      name: "並び順",
      key: "sortOrder",
    },
    {
      name: "コメント",
      key: "comment"
    }
  ]
}

export function constructDemandDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      "name" : "品目コード",
      "key" : "itemCode",
    },
    {
      "name" : "納期",
      "key": "let"
    },
    {
      name: "受注数",
      key: "quantity",
    },
    {
      name: "オーダコード",
      key: "orderCode",
    }
  ]
}


export function constructInventoryDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      name: "品目コード",
      key: "itemCode",
    },
    {
      name: "在庫日付",
      key: "let",
    },
    {
      name: "在庫数",
      key: "quantity",
    },
  ]
}

export function constructItemDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      name: "有効/無効フラグ",
      key: "isSolverApplied",
    },
    {
      name: "品目コード",
      key: "itemCode",
    },
    {
      name: "資源コード",
      key: "resourceCode",
    },
    {
      name: "製造能力",
      key: "productionCapacity",
    }
  ]
}

export function constructParameterDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {name: "品目コード", key: "itemCode"},
    {name: "製造ロットサイズUnit", key: "manufacturingOrderQuantityUnit"},
    {name: "自動固定日数", key: "scheduleFixedDays"},
    {
      name: "Max在庫厳守",
      key: "inventoryMaxEnforcementPolicy",
      getString: item => {
        switch (item.inventoryMaxEnforcementPolicy) {
          case "1":
            return "厳守する"
          default:
            return "厳守しない"
        }
      }
    },
    {name: "Max在庫数量", key: "inventoryMaxByQuantity"},
    {name: "Max在庫日数", key: "inventoryMaxByDaysInInventory"},
    {name: "Min在庫数量", key: "inventoryMinByQuantity"},
    {name: "Min在庫日数", key: "inventoryMinByDaysInInventory"},
    {name: "最小ロットサイズ", key: "manufacturingOrderQuantityMin"},
    {
      name: "週次内示対象品目",
      key: "isWeeklyForecastApplied",
      getString: item => {
        switch (item.isWeeklyForecastApplied) {
          case "1":
            return "適用する"
          default:
            return "適用しない"
        }
      }
    },
    {name: "内示n週分", key: "inventoryMaxByWeeksOnForecast"},
    {
      name: "ロット在庫有",
      key: "allowInventoryMaxViolationWhenManufacturingInLots",
      getString: item => {
        switch (item.allowInventoryMaxViolationWhenManufacturingInLots) {
          case "1":
            return "許容する"
          default:
            return "許容しない"
        }
      }
    },
    {name: "補充開始日", key: "solverStartDate"},
    {
      name: "生産可能曜日",
      key: "productionAllowedDaysOfWeek",
      getString: item => {
        return (item.productionAllowedDaysOfWeek?.split(";") ?? [])
          .filter(key => key)
          .map(key => {
            switch (key) {
              case "1":
                return "月"
              case "2":
                return "火"
              case "3":
                return "水"
              case "4":
                return "木"
              case "5":
                return "金"
              case "6":
                return "土"
              case "7":
                return "日"
            }
          })
          .join(",")
      }
    },
    {name: "生産可能日", key: "productionAllowedDates"},
  ]
}

export function constructProductionDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      name: "品目コード",
      key: "itemCode",
    },
    {
      name: "納期",
      key: "let",
    },
    {
      name: "割付先資源コード",
      key: "assignedResourceCode",
    },
    {
      name: "生産数",
      key: "quantity",
    },
    {
      name: "外部確定",
      key: "isFixedExternally",
    }
  ]
}

export function constructShiftDataPropertiesHeaders(extraHeaders = []) {
  return [
    ...extraHeaders,
    {
      name: "シフトコード",
      key: "shiftCode"
    },
    {
      name: "パターン",
      key: "pattern",
    },
    {
      name: "コメント",
      key: "comment",
    }
  ]
}

export function getDataPropertiesHeadersConstructor(dataType) {
  switch (dataType) {
    case "calendar":
      return extraColumns => constructCalendarDataPropertiesHeaders(extraColumns)
    case "demand":
      return extraColumns => constructDemandDataPropertiesHeaders(extraColumns)
    case "inventory":
      return extraColumns => constructInventoryDataPropertiesHeaders(extraColumns)
    case "item":
      return extraColumns => constructItemDataPropertiesHeaders(extraColumns)
    case "parameter":
      return extraColumns => constructParameterDataPropertiesHeaders(extraColumns)
    case "production":
      return extraColumns => constructProductionDataPropertiesHeaders(extraColumns)
    case "shift":
      return extraColumns => constructShiftDataPropertiesHeaders(extraColumns)
    default:
      throw new Error(`Unknown data type ${dataType}`)
  }
}
